import React, {useState, useEffect, useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import InstituteTemplate from "../../Components/InstituteTemplate/InstituteTemplate";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import useCheckLogin from "../../Helpers/CustomHooks/CheckLogin";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";
import DesktopTabsForInvehicleRecordings from "./DesktopTabsForInvehicleRecordings/DesktopTabsForInvehicleRecordings";
import { socket } from "../../Components/InVehicleClass/socket"; 
import { getAllCompleteEvents } from "../InVehicleRecording/api";
import { transformData } from "../../Helpers/utils/liveData";
import CustomeMediaPlayer from "../InVehicleRecording/MediaPlayer";
import InclassLiveRecordings from "./LiveRecordings/LiveRecordings";
import InVehicleCompletedLessons from "./InVehicleCompletedLessons/InVehicleCompletedLessons";
import { Dialog, DialogContent } from "@mui/material";
import TrackAdminGoogleMap from "../InVehicleRecording/AdminGoogleMap/TrackGoogleMap";
import TrackCustomeMediaPlayer from "../InVehicleRecording/TrackMediaPlayer";
import AdminGoogleMap from "../InVehicleRecording/AdminGoogleMap";
import moment from 'moment'

const InVehicleLessonsRecordingsChild= () => {
    const Dispatch = useDispatch();
       
    const [activeTab, setActiveTab] = useState("LiveRecording");
    const { loading } = useSelector(
        (Store) => Store.StudentReducer
      );

    const InstituteId = GetLocalStorage("UserInfo")?.Institute?.InstituteId
    console.log("InstituteId in InclassLiveRecordings is:", InstituteId)

    const [liveClasses, setLiveClasses] = useState();
    const [liveStream, setLiveStream] = useState();
    const [completedClasses, setCompletedClasses] = useState();
    const [compClassError, setCompClassError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [map, setMap] = useState(null);
    const [locationModal, setLocationModal] = useState("");
    const [currentPosition, setCurrentPosition] = useState();
    const [currentRoute, setCurrentRoute] = useState([]);
    const [savedLocationModal, setSavedLocationModal] = useState("");
    const [videoChunks, setVideoChunks] = React.useState([]);
    const [videoTime, setVideoTime] = useState(0); // Store the current video time
    const [filterOpen, setFilterOpen] = useState(false);
    const [filters, setFilters] = useState({
        LearnerName: '',
        InstructorName:'',
        sortOrder: '',
        RecordingDate : null,
    });
    const [applyFilterClicked, setApplyFilterClicked] = useState(false);

    const handleApplyFilters = () => {
        setApplyFilterClicked(true);
        setFilterOpen(false);
    };

    const handleResetFilters = () => {
        setFilters({
          LearnerName: '',
          InstructorName:'',
          sortOrder: '',
          RecordingDate : null,
        });
        setApplyFilterClicked(false);
    };  

    useCheckLogin(true, ["Institute"], ["Admin"]);

    useEffect(() => {
        getLiveSession();
        socket.on("live-finish", (data) => {
        if (data.message === "completed") {
            setLiveClasses();
        }
        });

        socket.on("track-location", (data) => {
        if (data) {
            setCurrentRoute((old) => [...old, data]);
            setCurrentPosition(data);
        }
        });

        socket.on("track-stop", () => {
        console.log(currentRoute);
        });
    }, [liveStream, currentPosition]);

    useEffect(() => {
        getcompletedEvents();
    }, []);

    const getcompletedEvents = () => {
        setIsLoading(true);
        getAllCompleteEvents(InstituteId)
        .then((res) => {
            setIsLoading(false);
            console.log("API RESPONSE:", res.data);
            if (res.data.message === "Completed classes retrieved successfully") {
                const transformed = transformData(res.data.data);
                setCompletedClasses(transformed);
                console.log("TRANSFORMED:", transformed);
            }
            else setCompClassError(res.data.error_message);
        })
        .catch((error) => {
            setIsLoading(false);
            setCompClassError(error.message);
        });
    };

    const getLiveSession = () => {
        socket.on("live-stream", async (liveEvent) => {
        if (liveEvent) {
            console.log("liveEvent",liveEvent);
        try {
            console.log("liveEvent received", liveEvent);
    
            // Append the new video chunk to the videoChunks array
            setVideoChunks((prevChunks) => [...prevChunks, liveEvent]);
    
            // Convert the chunks to a Blob and create an Object URL
            const videoBlob = new Blob(videoChunks, { type: "video/mp4" }); // Make sure MIME type matches your stream format
            const videoURL = URL.createObjectURL(videoBlob);
    
            // Set the object URL as the video source
            setLiveStream(videoURL);
    
        } catch (error) {
            console.error("Error processing live stream:", error);
        }
        }
        });

        socket.on("live-classes", (classes) => {

            console.log("classes received:", classes);

            if (!Array.isArray(classes)) {
              console.error("Expected array but got:", classes);
              return;
            }
          
            const filteredClasses = classes.filter((event) => {
              const instituteIdFromEvent =
              event?.CourseEnrollment?.CoursePackage?.InstituteCourse?.InstituteFK;

              return instituteIdFromEvent === InstituteId;
            });

        const transformedData = transformData(filteredClasses);
        if (classes) setLiveClasses(transformedData);
        });
    };

    const [isMapReady, setIsMapReady] = useState(false);
    const [isVideoReady, setIsVideoReady] = useState(false);

    const handleMapReady = () => setIsMapReady(true);
    const handleVideoReady = () => setIsVideoReady(true);

    const bothReady = isMapReady && isVideoReady;

    const filteredCompletedClasses = useMemo(() => {
        if (!completedClasses) return [];
    
        let data = [...completedClasses];
    
        // Filter by Learner Name
        if (filters.LearnerName) {
            data = data.filter(item =>
                item.studentName?.toLowerCase().includes(filters.LearnerName.toLowerCase())
            );
        }
    
        // Filter by Instructor Name
        if (filters.InstructorName) {
            data = data.filter(item =>
                item.instructorName?.toLowerCase().includes(filters.InstructorName.toLowerCase())
            );
        }
    
        // Filter by Date
        if (filters.RecordingDate) {
            const selectedDate = new Date(filters.RecordingDate).toDateString();
    
            data = data.filter(item =>
                new Date(item.startTime).toDateString() === selectedDate
            );
        }
    
        // Sort
        const parseDate = (dateStr) => {
            if (!dateStr) return 0;
        
            return moment(dateStr, "M/D/YYYY, h:mm:ss A").valueOf();
        };
        
        const sortOrder = filters.sortOrder;

        data = [...data].sort((a, b) => {
            const timeA = parseDate(a.startTime);
            const timeB = parseDate(b.startTime);

            if (sortOrder === "asc") return timeA - timeB;
            if (sortOrder === "desc") return timeB - timeA;
            return 0;
        });
    
        setApplyFilterClicked(false);

        return data;
    }, [completedClasses, filters, applyFilterClicked]);

      // Function to render the right-side content based on the active tab
    const renderContent = () => {
        switch (activeTab) {
           case "LiveRecording":
                return <InclassLiveRecordings liveClassesData={liveClasses} setLocationModal={setLocationModal} setLiveStream={setLiveStream} />;
            case "Recorded":
                return <InVehicleCompletedLessons completedClasses={filteredCompletedClasses}
                setLiveStream={setLiveStream}
                setSavedLocationModal={setSavedLocationModal} />;
           default:
        }
    };
    
    return (
        <>
         {!loading ? (
              <>
                <DesktopTabsForInvehicleRecordings setActiveTab={setActiveTab} activeTab={activeTab} filterOpen={filterOpen} setFilterOpen={setFilterOpen} filters={filters} setFilters={setFilters}
                onApply={handleApplyFilters} handleResetFilters={handleResetFilters} />
                <div className="pb-[100px] bg-[#FFFFFF]">
                    {renderContent()}
                </div>

                {liveStream && (
                    <CustomeMediaPlayer
                    open={Boolean(liveStream)}
                    onClose={() => setLiveStream("")}
                    media={liveStream}
                    controls={true}
                    />
                )}

                {savedLocationModal && (
                    <Dialog
                    open={Boolean(savedLocationModal)}
                    onClose={() => {
                        setSavedLocationModal("");
                        setLiveStream("");
                    }}
                    fullWidth
                    maxWidth="md" // Adjust based on how wide you need the dialog
                    PaperProps={{
                        style: {
                        zIndex: 20000, // higher than sidebar
                        position: "relative",
                        },
                    }}
                    >
                    <DialogContent>
                        <div className="flex flex-row justify-between items-start gap-4 z-99999">
                        <TrackAdminGoogleMap
                        onLoadMap={(map) => setMap(map)}
                            locationKey={savedLocationModal}
                            modal={{
                            open: Boolean(savedLocationModal),
                            onClose: () => setSavedLocationModal(""),
                            }}
                            videoTime={videoTime}
                            />
                        
                        <TrackCustomeMediaPlayer
                            open={Boolean(liveStream)}
                            onClose={() => setLiveStream("")}
                            media={liveStream}
                            controls={true}
                            onTimeUpdate={(time) => setVideoTime(time)} // Update video time
                            />
                        </div>
                    </DialogContent>
                    </Dialog>
                )}  

                {locationModal && (
                    <AdminGoogleMap
                    currentPosition={currentPosition}
                    currentRoute={currentRoute}
                    onLoadMap={(map) => setMap(map)}
                    modal={{
                        open: Boolean(locationModal),
                        onClose: () => setLocationModal(""),
                    }}
                    />
                )} 
              </>
         ) :  (
              <LoadingSpinner
              Height="[500px]"
              Width="[99%]"
              Top="[80px]"
              Left="0"
              Position="relative"
            />
         )}
        </>
    );
};


const InVehicleLessonsRecordings = () => (
    <InstituteTemplate
      Element={InVehicleLessonsRecordingsChild}
      m_top="mt-0"
      bg="bg-[#F0F0F7]"
    />
  );

export default InVehicleLessonsRecordings;
